/**
 * i18n – Tiếng Việt
 * Tất cả text hiển thị trên UI được tập trung tại đây.
 * Dùng hàm t() từ index.ts để tra cứu key có type-safety.
 */
const vi = {
  // ─── Common ───────────────────────────────────────────────────────────────
  common: {
    appName: 'D6 Portal',
    loading: 'Đang tải…',
    error: 'Lỗi',
    save: 'Lưu',
    cancel: 'Huỷ',
    add: 'Thêm',
    edit: 'Sửa',
    search: 'Tìm',
    prev: 'Trước',
    next: 'Sau',
    /** Dùng với template: t('common.page', { page, total }) */
    page: 'Trang {page} / {total}',
    all: 'Tất cả',
    logout: 'Đăng xuất',
    back: 'Quay lại',
    close: 'Đóng',
    notification: 'Thông báo',
    noNotification: 'Chưa có thông báo',
    connecting: 'Đang kết nối lại...',
    disconnected: 'Mất kết nối',
  },

  // ─── Chat ─────────────────────────────────────────────────────────────────
  chat: {
    title: 'Trò chuyện',
    empty: 'Chưa có tin nhắn nào',
    placeholder: 'Nhập tin nhắn...',
    unknownSender: 'Ẩn danh',
    hostBadge: 'Host',
  },

  // ─── Game Types ───────────────────────────────────────────────────────────
  gameTypes: {
    quiz: 'Đố vui',
    word_scramble: 'Vua Tiếng Việt',
    selectLabel: 'Loại trò chơi',
  },

  // ─── Auth ─────────────────────────────────────────────────────────────────
  login: {
    title: 'Đăng nhập',
    emailLabel: 'Email',
    emailPlaceholder: 'you@vnext.vn',
    passwordLabel: 'Mật khẩu',
    passwordPlaceholder: '••••••••',
    submitButton: 'Đăng nhập',
    divider: 'hoặc',
    authenticating: 'Đang xác thực...',
    errorGeneric: 'Đăng nhập thất bại. Vui lòng thử lại.',
    errorCredentials: 'Email hoặc mật khẩu không đúng.',
  },

  denied: {
    title: 'Không có quyền truy cập',
    description: 'Email của bạn chưa được cấp quyền tham gia hệ thống.',
    hint: 'Vui lòng liên hệ Admin để được thêm vào danh sách.',
    backToLogin: 'Quay lại đăng nhập',
  },

  notFound: {
    code: '404',
    title: 'Trang không tồn tại',
    description: 'Đường dẫn bạn đang truy cập không tồn tại hoặc đã bị xoá.',
    home: 'Về trang chủ',
  },

  // ─── Layout ───────────────────────────────────────────────────────────────
  adminLayout: {
    navEmployees: 'Nhân viên',
    navQuestions: 'Câu hỏi',
    navRounds: 'Màn chơi',
    navRpsRooms: 'Đấu BKB',
    navWordChain: 'Nối Từ',
  },

  userLayout: {
    navLobby: 'Lobby',
    navRpsRooms: 'Đấu BKB',
    navHistory: 'Lịch sử',
  },

  // ─── Admin – Employees ────────────────────────────────────────────────────
  employees: {
    pageTitle: 'Nhân viên',
    addButton: 'Thêm',
    searchPlaceholder: 'Tìm theo email, tên…',
    filterAdmin: 'Admin',
    filterUser: 'User',
    emptyTitle: 'Chưa có nhân viên nào',
    emptyDescription: 'Thêm email để cho phép đăng nhập.',
    colEmployee: 'Nhân viên',
    colRole: 'Vai trò',
    colStatus: 'Trạng thái',
    colLastLogin: 'Đăng nhập gần nhất',
    badgeActive: 'Hoạt động',
    badgeLocked: 'Đã khoá',
    editTitle: 'Sửa',
    lockTitle: 'Khoá',
    unlockTitle: 'Mở khoá',
    modalAddTitle: 'Thêm nhân viên',
    modalEditTitle: 'Sửa nhân viên',
    fieldEmail: 'Email *',
    emailPlaceholder: 'ten@company.com',
    fieldDisplayName: 'Tên hiển thị',
    displayNamePlaceholder: 'Nguyễn Văn A',
    fieldRole: 'Vai trò',
    roleUser: 'User',
    roleAdmin: 'Admin',
    fieldEmailEdit: 'Email',
    fieldActive: 'Đang hoạt động',
    saveButton: 'Lưu',
    toastAdded: 'Đã thêm nhân viên',
    toastUpdated: 'Đã cập nhật',
    validationEmail: 'Email không hợp lệ',
  },

  // ─── Admin – Questions ────────────────────────────────────────────────────
  questions: {
    pageTitle: 'Kho câu hỏi',
    createButton: 'Tạo mới',
    searchPlaceholder: 'Tìm câu hỏi…',
    filterArchived: 'Đã lưu trữ',
    emptyTitle: 'Kho câu hỏi trống',
    emptyDescription: 'Tạo câu hỏi đầu tiên để bắt đầu.',
    colQuestion: 'Câu hỏi',
    colAnswer: 'Đáp án',
    colDifficulty: 'Độ khó',
    colTime: 'Thời gian',
    editTitle: 'Sửa',
    restoreTitle: 'Khôi phục',
    archiveTitle: 'Lưu trữ',
    modalEditTitle: 'Sửa câu hỏi',
    modalCreateTitle: 'Tạo câu hỏi mới',
    fieldQuestion: 'Câu hỏi *',
    questionPlaceholder: 'Thủ đô của Việt Nam là gì?',
    validationQuestion: 'Nhập câu hỏi',
    fieldAcceptedAnswers: 'Đáp án được chấp nhận *',
    /** Dùng với template: t('questions.answerPlaceholder', { i }) */
    answerPlaceholder: 'Đáp án {i}',
    validationAnswerEmpty: 'Không để trống',
    addAnswer: '+ Thêm đáp án',
    validationAnswerMin: 'Cần ít nhất 1 đáp án',
    fieldDisplayAnswer: 'Đáp án hiển thị *',
    displayAnswerFallback: 'Hà Nội',
    validationDisplayAnswer: 'Nhập đáp án hiển thị',
    fieldDifficulty: 'Độ khó',
    difficultyEasy: 'Dễ',
    difficultyMedium: 'Trung bình',
    difficultyHard: 'Khó',
    fieldTime: 'Thời gian (giây)',
    fieldBaseScore: 'Điểm cơ bản',
    fieldTags: 'Tags (cách bởi dấu phẩy)',
    tagsPlaceholder: 'lịch sử, địa lý',
    saveButton: 'Lưu',
    fieldGameType: 'Loại câu hỏi *',
    fieldExplanation: 'Giải thích đáp án',
    explanationPlaceholder: 'Vd: Hà Nội là thủ đô từ năm 1010...',
    colUsed: 'Đã dùng',
    toastCreated: 'Đã tạo câu hỏi',
    toastUpdated: 'Đã cập nhật',
    toastArchived: 'Đã lưu trữ',
    toastRestored: 'Đã khôi phục',
    fieldAnswerFormat: 'Dạng trả lời',
    answerFormatText: 'Tự luận',
    answerFormatMultipleChoice: 'Trắc nghiệm',
    fieldChoices: 'Lựa chọn (4 đáp án)',
    /** Dùng với template: t('questions.choicePlaceholder', { i }) */
    choicePlaceholder: 'Lựa chọn {i}',
    choiceCorrectTitle: 'Chọn đáp án đúng',
    choiceCorrectHint: 'Tick chọn ô tròn bên trái lựa chọn đúng.',
    validationChoiceEmpty: 'Không để trống',
    validationChoiceDuplicate: '4 lựa chọn không được trùng nhau',
  },

  // ─── Admin – Rounds List ──────────────────────────────────────────────────
  roundsList: {
    pageTitle: 'Màn chơi',
    createButton: 'Tạo mới',
    emptyTitle: 'Chưa có màn chơi nào',
    emptyDescription: 'Tạo màn chơi đầu tiên để bắt đầu.',
    /** Dùng với template: t('roundsList.questions', { n }) */
    questions: '{n} câu',
    /** Dùng với template: t('roundsList.timePerQuestion', { n }) */
    timePerQuestion: '{n}s/câu',
    /** Dùng với template: t('roundsList.players', { n }) */
    players: '{n} người',
    editButton: 'Sửa',
    openRoom: 'Mở phòng',
    cancelRound: 'Huỷ màn chơi này?',
    enterWaitingRoom: 'Vào phòng chờ',
    continueControl: 'Tiếp tục điều khiển',
    viewResult: 'Xem kết quả',
    toastOpened: 'Đã mở phòng',
    toastOpenFailed: 'Không thể mở phòng',
    toastCancelled: 'Đã huỷ màn chơi',
    toastCancelFailed: 'Không thể huỷ',
  },

  // ─── Admin – Round Edit ───────────────────────────────────────────────────
  roundEdit: {
    createTitle: 'Tạo màn chơi mới',
    editTitle: 'Sửa màn chơi',
    sectionConfig: 'Cấu hình',
    fieldName: 'Tên màn chơi *',
    namePlaceholder: 'Đố vui cuối tuần',
    validationName: 'Nhập tên màn chơi',
    fieldDescription: 'Mô tả',
    descriptionPlaceholder: 'Chủ đề lịch sử...',
    fieldQuestionCount: 'Số câu',
    fieldTimePerQuestion: 'Thời gian/câu (s)',
    fieldBaseScore: 'Điểm cơ bản',
    fieldBonusMax: 'Điểm thưởng tối đa',
    fieldScoreFormula: 'Công thức điểm',
    formulaLinear: 'Linear (thưởng theo tốc độ)',
    formulaStep: 'Step (thưởng theo bậc)',
    formulaFixed: 'Fixed (không có thưởng)',
    fieldPin: 'PIN code (tùy chọn)',
    pinPlaceholder: 'Để trống nếu không cần',
    allowSpectator: 'Cho phép vào trễ làm spectator',
    fieldGameType: 'Loại trò chơi *',
    gameTypeHint: 'Chỉ random câu hỏi cùng loại',
    saveConfig: 'Lưu cấu hình',
    createAndContinue: 'Tạo & tiếp tục',
    sectionQuestions: 'Câu hỏi',
    randomize: 'Random câu hỏi',
    mixQuestionTypes: 'Trộn cả câu hỏi Đố Vui và Vua Tiếng Việt',
    mixQuestionTypesHint: 'Random lẫn cả 2 loại câu hỏi (Đố Vui + Vua Tiếng Việt) vào màn chơi này. Mỗi câu sẽ hiển thị đúng theo loại của nó.',
    onlyMultipleChoice: 'Toàn bộ câu hỏi là trắc nghiệm (4 đáp án)',
    onlyMultipleChoiceHint: 'Chỉ random trong các câu hỏi trắc nghiệm đã tạo ở Ngân hàng câu hỏi.',
    formatBadgeMultipleChoice: 'Trắc nghiệm',
    formatBadgeText: 'Tự luận',
    /** Dùng với template: t('roundEdit.questionCount', { n }) */
    questionCount: '{n} câu',
    saveAndSimulate: 'Lưu & Mô phỏng',
    toastCreated: 'Đã tạo màn chơi',
    toastSaved: 'Đã lưu',
    toastSavedAndSimulated: 'Đã lưu câu hỏi & mô phỏng',
  },

  // ─── Admin – Round Control ────────────────────────────────────────────────
  roundControl: {
    fallbackRoundName: 'Màn chơi',
    start: 'Bắt đầu',
    end: 'Kết thúc',
    /** Dùng với template: t('roundControl.countdown', { countdown }) */
    countdown: 'Game bắt đầu sau {countdown}s',
    pinLabel: 'PIN',
    /** Dùng với template: t('roundControl.questionsMeta', { n }) */
    questionsMeta: '{n} câu',
    /** Dùng với template: t('roundControl.timeMeta', { n }) */
    timeMeta: '{n}s/câu',
    /** Dùng với template: t('roundControl.waitingCount', { n }) */
    waitingCount: '{n} người đang chờ',
    emptyParticipants: 'Chưa có ai vào phòng. Chia sẻ mã PIN hoặc link tham gia.',
    fallbackPlayerName: 'Người chơi',
    countdownOverlay: 'Game bắt đầu sau',
    countdownUnit: 'giây',
    /** Dùng với template: t('roundControl.startButton', { n }) */
    startButton: 'Bắt đầu game ({n} người)',
    /** Dùng với template: t('roundControl.questionProgress', { n, total }) */
    questionProgress: 'Câu {n} / {total}',
    answerLabel: 'Đáp án:',
    /** Dùng với template: t('roundControl.answeredCount', { n, m }) */
    answeredCount: '{n} / {m} người đã trả lời',
    revealAnswer: 'Hiện đáp án',
    /** Dùng với template: t('roundControl.autoAdvance', { n }) */
    autoAdvance: 'Câu tiếp sau {n}s',
    skip: 'Bỏ qua',
    endGame: 'Kết thúc game',
    leaderboard: 'Bảng điểm',
    gameEnded: 'Game đã kết thúc!',
    /** Dùng với template: t('roundControl.score', { n }) */
    score: '{n} điểm',
    colRank: '#',
    colPlayer: 'Người chơi',
    colScore: 'Điểm',
    colCorrect: 'Đúng',
    createNewRound: 'Tạo màn chơi mới',
    confirmEnd: 'Kết thúc màn chơi? Hành động này không thể hoàn tác.',
    muteMusic: 'Tắt nhạc',
    unmuteMusic: 'Bật nhạc',
    /** Dùng với template: t('roundControl.transitionCountdown', { n, total }) */
    transitionCountdown: 'Chuẩn bị câu {n} / {total}',
    scoreboardTitle: 'Bảng điểm',
  },

  // ─── User – Lobby ─────────────────────────────────────────────────────────
  lobby: {
    /** Dùng với template: t('lobby.greeting', { name }) */
    greeting: 'Xin chào, {name}!',
    subtitle: 'Chọn màn chơi bên dưới để tham gia',
    sectionTitle: 'Màn chơi đang mở',
    refresh: 'Làm mới',
    emptyTitle: 'Chưa có màn chơi nào',
    emptyDescription: 'Đợi admin mở phòng nhé! Trang sẽ tự cập nhật.',
    pinModalTitle: 'Nhập PIN phòng',
    /** Dùng với template: t('lobby.pinHint', { name }) */
    pinHint: 'Phòng {name} yêu cầu PIN để vào.',
    pinPlaceholder: 'Nhập mã PIN…',
    pinValidation: 'Nhập PIN',
    enterRoom: 'Vào phòng',
    statusOpen: 'Đang mở phòng',
    statusPlaying: 'Đang chơi',
    /** Dùng với template: t('lobby.host', { name }) */
    host: 'Host: {name}',
    /** Dùng với template: t('lobby.timePerQuestion', { n }) */
    timePerQuestion: '{n}s/câu',
    /** Dùng với template: t('lobby.players', { n }) */
    players: '{n} người',
    watchAsSpectator: 'Vào xem (khán giả)',
    joinRoom: 'Vào phòng',
  },

  // ─── User – Waiting Room ──────────────────────────────────────────────────
  waitingRoom: {
    fallbackRoundName: 'Đang tải...',
    pinLabel: 'PIN:',
    configQuestions: 'Số câu',
    configTime: 'Thời gian/câu',
    /** Dùng với template: t('waitingRoom.timeValue', { n }) */
    timeValue: '{n}s',
    waitMessage: 'Chờ admin bắt đầu...',
    /** Dùng với template: t('waitingRoom.playerCount', { n }) */
    playerCount: '{n} người trong phòng',
    fallbackPlayerName: 'Người chơi',
    leaveRoom: 'Rời phòng',
    countdownOverlay: 'Game sắp bắt đầu!',
    countdownUnit: 'giây',
    gameIntroTitle: 'Giới thiệu trò chơi',
    rulesTitle: 'Luật chơi',
    scoringTitle: 'Tính điểm',
    quizIntro: 'Đố Vui — Trả lời đúng câu hỏi kiến thức tổng hợp.',
    wordScrambleIntro: 'Vua Tiếng Việt — Sắp xếp lại các từ bị xáo trộn thành cụm từ có nghĩa.',
    rules: 'Mỗi câu có thời gian giới hạn. Trả lời đúng và nhanh nhất sẽ nhận điểm thưởng cao nhất. Chỉ được gửi đáp án một lần.',
    scoringExplain: 'Điểm = Điểm cơ bản + Điểm thưởng tốc độ. Người trả lời đúng sớm nhất nhận điểm thưởng cao nhất.',
  },

  // ─── User – Play ──────────────────────────────────────────────────────────
  play: {
    waitingFirstQuestion: 'Đang chờ câu hỏi đầu tiên...',
    spectatorBanner: 'Bạn đang xem - không tính điểm',
    /** Dùng với template: t('play.questionProgress', { n, total }) */
    questionProgress: 'Câu {n} / {total}',
    submitted: 'Đã gửi!',
    answerPlaceholder: 'Nhập đáp án của bạn...',
    submitDone: 'Đã gửi',
    submit: 'Gửi',
    waitResult: 'Chờ kết quả...',
    spectatorNote: 'Đang chờ người chơi trả lời...',
    revealPhase1Label: 'Kết quả',
    revealPhase2Label: 'Bảng xếp hạng',
    /** Dùng với template: t('play.nextCountdown', { n }) */
    nextCountdown: 'câu tiếp sau {n}s',
    correctAnswerLabel: 'Đáp án đúng:',
    /** Dùng với template: t('play.scoreCorrect', { score }) */
    scoreCorrect: '+{score} điểm',
    scoreWrong: 'Sai rồi - 0 điểm',
    scoreTimeout: 'Hết giờ - 0 điểm',
    phase1CardTitle: 'Điểm câu này',
    noOneCorrect: 'Không ai trả lời đúng',
    fastestTitle: 'Trả lời nhanh nhất',
    noOneAnswered: 'Chưa ai trả lời',
    badgeCorrect: 'Đúng',
    badgeWrong: 'Sai',
    leaderboardTitle: 'Bảng xếp hạng',
    newRankBadge: 'MỚI',
    sameRank: '-',
    wordScrambleInstruction: 'Hãy sắp xếp lại thành từ có ý nghĩa',
    wordScrambleLabel: 'Sắp xếp lại cụm từ:',
    explanationLabel: 'Giải thích:',
    nextQuestionTitle: 'Câu tiếp theo',
    nextQuestionIn: 'Bắt đầu sau',
    nextQuestionUnit: 'giây',
  },

  // ─── User – Result ────────────────────────────────────────────────────────
  result: {
    pageTitle: 'Kết quả màn chơi',
    /** Dùng với template: t('result.rank', { rank }) */
    rank: '#{rank}',
    scoreLabel: 'điểm',
    /** Dùng với template: t('result.correctCount', { n }) */
    correctCount: '{n} câu đúng',
    detailButton: 'Xem chi tiết của tôi',
    leaderboardTitle: 'Bảng xếp hạng đầy đủ',
    fallbackPlayerName: 'Người chơi',
    backToLobby: 'Về Lobby',
    drawerTitle: 'Chi tiết của tôi',
    drawerLoading: 'Đang tải...',
    drawerError: 'Không thể tải chi tiết.',
    /** Dùng với template: t('result.drawerRank', { rank }) */
    drawerRank: 'Hạng #{rank}',
    /** Dùng với template: t('result.drawerScore', { score }) */
    drawerScore: '{score} điểm',
    /** Dùng với template: t('result.drawerCorrect', { correct, total }) */
    drawerCorrect: '{correct}/{total} đúng',
    /** Dùng với template: t('result.avgTime', { n }) */
    avgTime: 'TB {n}s',
    answerLabel: 'Bạn: ',
    noAnswer: 'Không trả lời',
    correctAnswerLabel: 'Đáp án: ',
    /** Dùng với template: t('result.answerScore', { score }) */
    answerScore: '{score} điểm',
  },

  // ─── User – History ───────────────────────────────────────────────────────
  history: {
    pageTitle: 'Lịch sử của tôi',
    subtitle: 'Các màn chơi bạn đã tham gia',
    emptyTitle: 'Chưa có lịch sử',
    emptyDescription: 'Bạn chưa tham gia màn chơi nào. Vào Lobby để bắt đầu!',
    colRound: 'Màn chơi',
    colDate: 'Ngày',
    colRank: 'Hạng',
    colScore: 'Điểm',
    colCorrect: 'Đúng / Tổng',
    spectatorBadge: 'Đã xem',
    viewResult: 'Xem kết quả',
  },

  // ─── RPS Room (p2p — phòng đấu Búa Kéo Bao do thành viên tạo) ─────────────
  rpsRoom: {
    pageTitle: 'Đấu Búa Kéo Bao',
    pageSubtitle: 'Tạo phòng và rủ đồng nghiệp đấu 1v1',
    createRoom: 'Tạo phòng mới',
    sectionTitle: 'Phòng đang mở',
    refresh: 'Làm mới',
    emptyTitle: 'Chưa có phòng nào',
    emptyDescription: 'Hãy là người đầu tiên tạo phòng đấu!',
    statusWaiting: 'Đang chờ',
    statusPlaying: 'Đang đấu',
    statusEnded: 'Đã kết thúc',
    /** t('rpsRoom.owner', { name }) */
    owner: 'Chủ phòng: {name}',
    /** t('rpsRoom.maxGames', { n }) */
    maxGames: 'Đấu {n} ván',
    /** t('rpsRoom.timeLimit', { n }) */
    timeLimit: '{n}s/ván',
    hasOpponent: 'Đã đủ 2 người chơi',
    waitingOpponent: 'Đang chờ đối thủ',
    joinAsPlayer: 'Vào chơi',
    watchAsSpectator: 'Vào xem',

    // Modal tạo phòng
    createModalTitle: 'Tạo phòng đấu mới',
    nameLabel: 'Tên phòng',
    namePlaceholder: 'VD: Đấu trường buổi trưa',
    passwordLabel: 'Mật khẩu phòng',
    passwordPlaceholder: 'Người chơi cần mật khẩu này để vào',
    maxGamesLabel: 'Số ván đấu (lẻ, 1-9)',
    timeLimitLabel: 'Thời gian mỗi ván (giây)',
    create: 'Tạo phòng',
    nameRequired: 'Vui lòng nhập tên phòng',
    passwordRequired: 'Vui lòng nhập mật khẩu',

    // Modal nhập mật khẩu khi tham gia
    joinModalTitle: 'Tham gia phòng',
    /** t('rpsRoom.joinHint', { name }) */
    joinHint: 'Nhập mật khẩu của phòng "{name}" để trở thành người chơi, hoặc bỏ qua để vào xem.',
    passwordOptionalPlaceholder: 'Mật khẩu (bỏ trống để xem)',
    wrongPassword: 'Sai mật khẩu — bạn có thể vào xem với vai trò khán giả',
    enterAsPlayer: 'Vào chơi',
    enterAsSpectator: 'Vào xem',

    // Phòng chờ / trận đấu
    you: '(Bạn)',
    player1: 'Người chơi 1',
    player2: 'Người chơi 2',
    waitingForPlayer: 'Đang chờ người chơi…',
    ready: 'Sẵn sàng',
    cancelReady: 'Huỷ sẵn sàng',
    waitingOtherReady: 'Đang chờ đối thủ sẵn sàng…',
    fightingTitle: 'Trận đấu sắp bắt đầu',
    fightSubTitle: 'Sẵn sàng chiến đấu!',
    fightGo: 'BẮT ĐẦU!',
    /** t('rpsRoom.celebrateWinner', { name }) */
    celebrateWinner: '🎉 {name} chiến thắng!',
    shakeHint: 'Chuẩn bị… Ra chiêu!',
    /** t('rpsRoom.spectatorCount', { n }) */
    spectatorCount: '{n} khán giả',
    leaveRoom: 'Rời phòng',
    /** t('rpsRoom.gameNumber', { n, total }) */
    gameNumber: 'Ván {n}/{total}',
    chooseRock: 'Búa',
    choosePaper: 'Bao',
    chooseScissors: 'Kéo',
    waitingChoice: 'Đang chờ lựa chọn…',
    chosen: 'Đã chọn',
    youWin: 'Bạn thắng!',
    youLose: 'Bạn thua',
    draw: 'Hoà',
    matchEndedTitle: 'Trận đấu kết thúc',
    /** t('rpsRoom.matchScore', { p1, p2 }) */
    matchScore: 'Tỉ số: {p1} - {p2}',
    reasonOpponentLeft: 'Đối thủ đã rời trận',
    backToList: 'Về danh sách phòng',
    roomClosed: 'Phòng đã đóng',
    closedByOwner: 'Chủ phòng đã đóng phòng',

    // Chat
    playerBadge: 'Người chơi',
    chatTitle: 'Trò chuyện',
    chatPlaceholder: 'Nhập tin nhắn…',
    chatSend: 'Gửi',
  },

  // ─── Toast / Accessibility ────────────────────────────────────────────────
  toast: {
    regionLabel: 'Thông báo',
    closeLabel: 'Đóng',
  },
} as const;

export type I18nKey = typeof vi;
export default vi;

